export default __webpack_public_path__ + "static/media/multi-route-assigned-icon.e79a7fcd.svg";